import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="sdlcreative-loader-wrapper">
      <div className="sdlcreative-loader-container">
        {/* Animated Background */}
        <div className="loader-bg-animation"></div>

        {/* Main Loader Content */}
        <div className="loader-content">
          {/* Logo */}
          <div className="loader-logo-wrapper">
            <img
              src="/images/logo/logo.png"
              alt="Jack and Jill School"
              className="loader-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/logo/logo.png";
              }}
            />
            {/* Pulse Ring Animation */}
            <div className="loader-pulse-ring"></div>
          </div>

          {/* Loading Text */}
          <p className="loader-text">Loading...</p>

          {/* Animated Dots */}
          <div className="loader-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>

          {/* School Name */}
          <p className="loader-school-name">Jack & Jill School</p>
        </div>
      </div>
    </div>
  );
};

export default Loader;
